import { render, staticRenderFns } from "./batchPayConfirm.vue?vue&type=template&id=e88788bc&scoped=true"
import script from "./batchPayConfirm.vue?vue&type=script&lang=js"
export * from "./batchPayConfirm.vue?vue&type=script&lang=js"
import style0 from "./batchPayConfirm.vue?vue&type=style&index=0&id=e88788bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e88788bc",
  null
  
)

export default component.exports